const secret = '8A512FE2E4E2B6CDD53666AF56BE0E2D'

export default secret
